import { createSlice } from '@reduxjs/toolkit';

import { initialQuoteState } from './initialState';
import { createQuote } from 'src/thunk/quote';
import { ERequestStatus } from 'src/api/enumRequest';

const quoteSlice = createSlice({
  name: 'quote',
  initialState: initialQuoteState,
  reducers: {
    resetQuote: (state) => {
      state.createQuote.status = ERequestStatus.none;
      state.createQuote.quote = null;
    },
    setQuoteTestData: (state) => {
      state.createQuote.quote = {
        quote_id: '08fa79a3-634e-41c8-bd4e-0fa3d31edc99',
        source_currency_id: 'BTC',
        source_currency_amount: 0.06660962,
        price: 0.065464,
        instrument: 'ETHBTC',
        expiration: 599,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createQuote.pending, (state) => {
        state.createQuote.status = ERequestStatus.pending;
        state.createQuote.error = '';
      })
      .addCase(createQuote.fulfilled, (state, action) => {
        state.createQuote.status = ERequestStatus.success;
        state.createQuote.quote = action.payload.quote;
      })
      .addCase(createQuote.rejected, (state, action: any) => {
        state.createQuote.status = ERequestStatus.failed;
        state.createQuote.error = action.payload.message;
      });
  },
});

export const { resetQuote, setQuoteTestData } = quoteSlice.actions;
export default quoteSlice.reducer;
